export const type = 'form.timePickerV2';
